var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vision",
    transform: "translate(0 -1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5883",
    "data-name": "Rectangle 5883",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(0 1041)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "compass",
    transform: "translate(14 1055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M178.846,168.074l-7.312,2.813a1.125,1.125,0,0,0-.646.646l-2.812,7.313a1.125,1.125,0,0,0,1.454,1.454l7.313-2.812a1.125,1.125,0,0,0,.646-.646l2.813-7.312a1.125,1.125,0,0,0-1.454-1.454Zm-3.279,7.492-4.483,1.724,1.724-4.483,4.483-1.724Z",
    transform: "translate(-156.188 -156.187)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M36,3.938a3.937,3.937,0,0,0-7.8-.772A18,18,0,0,0,5.272,30.728,18,18,0,0,0,32.835,7.8,3.944,3.944,0,0,0,36,3.937ZM32.063,2.25a1.688,1.688,0,1,1-1.687,1.688A1.689,1.689,0,0,1,32.063,2.25ZM29.137,29.137A15.75,15.75,0,1,1,6.863,6.863,15.75,15.75,0,0,1,29.137,29.137Z",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M177.531,67.017a11.3,11.3,0,0,1,8.181,0,1.125,1.125,0,0,0,.819-2.1,13.547,13.547,0,0,0-9.819,0,1.125,1.125,0,1,0,.819,2.1Z",
    transform: "translate(-163.622 -59.5)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M185.711,404.074a11.3,11.3,0,0,1-8.181,0,1.125,1.125,0,0,0-.819,2.1,13.547,13.547,0,0,0,9.819,0,1.125,1.125,0,1,0-.819-2.1Z",
    transform: "translate(-163.62 -375.59)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M66.378,176.074a1.125,1.125,0,0,0-1.457.638,13.547,13.547,0,0,0,0,9.819,1.125,1.125,0,1,0,2.1-.819,11.3,11.3,0,0,1,0-8.181A1.125,1.125,0,0,0,66.378,176.074Z",
    transform: "translate(-59.5 -163.621)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M404.073,177.531a11.3,11.3,0,0,1,0,8.181,1.125,1.125,0,1,0,2.1.819,13.547,13.547,0,0,0,0-9.819,1.125,1.125,0,1,0-2.1.819Z",
    transform: "translate(-375.59 -163.622)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.6b4a6108a56632fdf88fbf1198b7ccbc.svg";
export { ForwardRef as ReactComponent };